module.exports = __webpack_public_path__ + "img/tu06.76025e5b.png";